import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/public-api';
import { IAccountItem } from './account-items.component';

@Component({
  template: '',
})
export class AccountItemsCardsComponent implements OnInit {
  @Input() cards: IAccountItem[];

  @Output() itemSelected = new EventEmitter<IAccountItem>();

  constructor(@Inject(ENVIRONMENT_TOKEN) protected environment: any) {}

  ngOnInit() {}

  useItem(item) {
    this.itemSelected.emit(item);
  }
}
